function Room(game, id) {
    this.world = game;
    this.id = id;
    this.loadedObjs = [];
}

Room.prototype.bgid =
    function () {
        return this.id + '-bg';
    };

Room.prototype.preload =
    function (manifest) {
        var queue = this.world.queue;

        queue.removeAll();

        if (manifest)
            queue.loadManifest(manifest);
    };

Room.prototype.load =
    function () {
        var queue = this.world.queue;

        this.bg = new createjs.Bitmap(queue.getResult(this.bgid()));
        this.bg.cursor = 'none';

        return this;
    };

Room.prototype.enter =
    function (narration) {

        this.world.narrator.post(narration || 'No narration available.');

        this.world.stage.addChild(this.bg);
        this.world.cursor.resetPosition();

        for (i = 0; i < this.loadedObjs.length; i++)
            this.world.stage.addChild(this.loadedObjs[i]);

        this.world.cursor.mount(this.world.stage);

        this.bg.name = this.bgid();
        createjs.Tween.get(this.bg).to({alpha: 1.0}, 1000);

        return this;
    };

Room.prototype.leave =
    function (nextKey) {
        createjs.Tween.removeAllTweens();

        createjs.Tween.get(this.bg)
            .to({alpha: 0.75}, 500)
            .call(goRoom, [this.next(nextKey || null)])
            .to({alpha: 0}, 1750);

        this.world.cursor.unmount();
        this.freeLoadedObjs();
        this.freeChildren([this.bg]);
    };

Room.prototype.freeChildren =
    function (children) {
        var stage = this.world.stage;

        window.setTimeout(
            function () {
                stage.removeChild.apply(stage, children);
            }.bind(this),
            3000
        );
    };

Room.prototype.freeLoadedObjs =
    function () {
        if (this.loadedObjs.length) {
            this.freeChildren(this.loadedObjs);
            this.loadedObjs = [];
        }
    };

Room.prototype.makeManifest =
    function (prefix, array) {
        var result = [];

        for (var i = 0; i < array.length; i++) {
            var o = {};
            var term = array[i];

            if (typeof term == 'object') {
                var ext = term.ext || 'png';

                if ((term.id || '') == '#scene') {
                    o.id = prefix + '-bg';
                    o.src = media(term.full_src || prefix + '-scene.' + ext);
                }
                else {
                    // The asset ID is full_id, if given, else PREFIX-id
                    o.id = term.full_id || (prefix + '-' + term.id);
                    o.src = media(term.full_src || term.id + '-' + term.src + '.' + ext);
                }
            }
            else {
                if (term == '#scene') {
                    o.id = prefix + '-bg';
                    o.src = media(prefix + '-scene.png');
                }
                else {
                    o.id = prefix + '-' + term;
                    o.src = media(prefix + '-' + term + '.png');
                }
            }

            result.push(o);
        }

        return result;
    };

Room.prototype.speechBalloon =
    function (params, text) {
        var bal = new createjs.Shape();
        var radius = params.r || 20;
        var wThorn = params.wThorn || 30;
        var hThorn = params.hThorn || 10;
        var tThorn = Math.max(params.tThorn || 30);

        var fg = this.world.pens.fgSpeech;
        var bg = this.world.pens.bgSpeech;

        bal.graphics.beginFill(bg).beginStroke(fg)
            .moveTo(wThorn, radius)
            .lineTo(wThorn, tThorn)
            .lineTo(0, tThorn + hThorn / 2)
            .lineTo(wThorn, tThorn + hThorn)
            .lineTo(wThorn, params.h - radius)
            .arc(wThorn + radius, params.h - radius, radius, d2(180), d2(90), true)
            .lineTo(wThorn + params.w - radius, params.h)
            .arc(wThorn + params.w - radius, params.h - radius, radius, d2(90), d2(0), true)
            .lineTo(wThorn + params.w, radius)
            .arc(wThorn + params.w - radius, radius, radius, d2(0), d2(270), true)
            .lineTo(wThorn + radius, 0)
            .arc(wThorn + radius, radius, radius, d2(270), d2(180), true);

        var sb = ujPut(new createjs.Container(), params.x, params.y);
        sb.addChild(bal);
        sb.addChild(ujPut(text, wThorn + 10, radius));

        return sb;
    };

Room.prototype.update =
    function () {
        this.world.stage.update();
    };


Room.prototype.makeHitRect =
    function (l, t, w, h, name, cursor) {
        var hitArea = new createjs.Shape();

        hitArea.graphics.beginFill(CTHRU).drawRect(l, t, w, h);
        hitArea.gameCursor = cursor || 'action';
        hitArea.name = 'area-' + name;

        return hitArea;
    };

Room.prototype.reg =
    function (dob) {
        this.loadedObjs.push(dob);
        dob.cursor = 'none';
    };


Room.prototype.setContainerCursor =
    function (dob, csr) {
        dob.gameCursor = csr;

        if (typeof dob.children != 'undefined') {
            for (var i = 0; i < dob.children.length; i++) {
                this.setContainerCursor(dob.children[i], csr);
            }
        }
    };

Room.prototype.resetCursor =
    function () {
        this.world.cursor.resetPosition();
    };

Room.prototype.data =
    function (key, val, id) {
        var xkey = (id || this.id) + '_' + key;

        if (typeof(val) != 'undefined')
            this.world.data[xkey] = val;

        return this.world.data[xkey];
    };
